/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Ownership_Transferred_DescInputs */



/**
* | output |
* | --- |
* | "Their shared spaces and projects were handed to another member, who is now an administrator of them. Personal spaces were not touched, and the departing memb..." |
*
* @param {Audit_Details_Member_Ownership_Transferred_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_ownership_transferred_desc = /** @type {((inputs?: Audit_Details_Member_Ownership_Transferred_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Ownership_Transferred_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die geteilten Spaces und Projekte wurden an ein anderes Mitglied übergeben, das nun deren Administrator ist. Persönliche Spaces bleiben unberührt, und der bisherige Zugriff bleibt bestehen, bis er separat entzogen wird.")
	return /** @type {LocalizedString} */ ("Their shared spaces and projects were handed to another member, who is now an administrator of them. Personal spaces were not touched, and the departing member keeps their own access until it is revoked separately.")
});